<template>
    <div v-if="announcements">
        <template v-for="announcement in announcements">
            <div
                class="alert alert-custom alert-white gutter-b"
                role="alert"
                :key="'announcement-' + announcement.id"
            >
                <div class="alert-icon">
                    <i class="fas fa-exclamation" :class="announcement.text_color"></i>
                </div>
                <div class="alert-text">
                    <h4 :class="announcement.text_color">{{ announcement.header }}</h4>
                    <p style="white-space: pre-wrap">{{ announcement.message }}</p>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import axios from "axios";
export default {
    name: "CustomAnnouncements",
    props: {
        page: String,
    },
    data() {
        return {
            announcements: [],
        };
    },
    methods: {
        getAnnouncements() {
            axios
                .get("announcements")
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Check status
                    if (data.status == "OK") {
                        // add each to array
                        data.data.forEach((currentItem) => {
                            currentItem.text_color = "text-" + currentItem.type;
                            currentItem.color = currentItem.type;
                            this.announcements.push(currentItem);
                        });

                        // Set the display to true
                        this.displayAnnouncements = true;
                    }
                })
                .catch((error) => {
                    // Do nothing
                })
                .finally(() => {
                    // Do nothing in case of error
                });
        },
    },
    mounted() {
        this.getAnnouncements();
    },
};
</script>
